// extracted by mini-css-extract-plugin
export default {"full-screen-loading":"pOGmPvmO_xvynPUJ_MgK"};